module.exports = __webpack_public_path__ + "img/abriron.66f754f1.png";